import { TextField } from '@recargas-dominicanas/core/components';
import type { IBusinessUser } from '@recargas-dominicanas/core/types';
import { useForm } from '../../../../utils/useForm';
import { Modal } from '../../../../components/modal/modal.component';
import { style } from './update-password-modal.module.css';
import { useState } from 'react';
import { BusinessApi } from '../../../../api/business.api';

interface Props {
  open: boolean;
  businessId: number;
  businessUser: IBusinessUser;
  onClose: () => void;
}

export function UpdatePasswordModal(props: Props) {

  const { 
    open, 
    businessId, 
    businessUser, 
    onClose 
  } = props;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  
  const form = useForm({
    password: { 
      value: '', 
      minLength: {
        length: 6,
        error: 'La contraseña debe tener al menos 6 caracteres'
      }
    }
  }, [open]);

  async function handleSave() {

    if (!form.validate()) return;

    try {
      
      setLoading(true);
      setError(undefined);

      await BusinessApi.updateUserPassword(businessId, businessUser.id, form.password.value);

      setLoading(false);
      handleClose();

    } catch {

      setLoading(false);
      setError('Ocurrio un error al actualizar la contraseña');
    }
  }

  function handleClose() {
    setError(undefined);
    onClose();
  }

  return (
    <Modal
      style={style.modal}
      open={open}
      title='Cambiar contraseña'
      error={error}
      secondaryButton='Guardar'
      disabledSecondaryButton={loading}
      onClose={handleClose}
      onSecondaryClick={handleSave}>
      <div className={style.item}>
        <div className={style.itemTitle}>Nombre de usuario</div>
        <div className={style.itemValue}>{businessUser.userName}</div>
      </div>
      <TextField 
        style={style.textField}
        label='Contraseña'
        value={form.password.value}
        error={form.password.error}
        onChange={form.password.onChange}
        onBlur={form.password.onBlur}/>
    </Modal>
  );
}
